export default __webpack_public_path__ + "static/media/search-icon.8ad1babf.svg";